module.exports = __webpack_public_path__ + "media/images/contact-1a2efd2a2989f280be10ce749d78328c.jpg";